export default __webpack_public_path__ + "static/media/syrie_carte_2-min_FR.1f33388a.png";